/**
 * check whether the schema belongs to ratings type
 * @param uiSchema ui json schema
 */
export function getIsRatingsBlock(uiSchema?: UISchema) {
  return uiSchema && uiSchema["ui:widget"] === "rating";
}
